import { Component, Input, OnInit } from '@angular/core';

import { CodemirrorSpellChecker, SupportedLang } from './codemirror-spellchecker';
import { AbstractModalWithResult } from '../../abstract-modal-with-result';

@Component({
  selector: 'app-spellchecker-language-selection',
  templateUrl: './spellchecker-language-selection.component.html',
  styleUrls: ['./spellchecker-language-selection.component.scss'],
})
export class SpellcheckerLanguageSelectionComponent extends AbstractModalWithResult<void> implements OnInit {
  static modalId = 'SpellcheckerLanguageSelectionComponent';

  @Input() spellChecker: CodemirrorSpellChecker;

  supportedLanguages: SupportedLang[];

  getModalId() {
    return SpellcheckerLanguageSelectionComponent.modalId;
  }

  ngOnInit() {
    this.supportedLanguages = Object.values(this.spellChecker.supportedLanguages);
  }

  selectLanguage(lang: SupportedLang) {
    this.spellChecker.setLanguageCode(lang.code);
    super.ok();
  }
}
